/* eslint-disable */
const SENSORS_MIN_APP_VERSION = '6.0101'; // GIO切换神策的最低版本，对应版本号为6.1.1
let SENSORS_ENV = 'test'; // 当前运行环境

function MySensors() {
    this.oldMemberId = ''; // 旧的会员ID
    this.eventQueue = []; // 脚本未加载完毕时的待处理事件队列

    // 代理GIO事件
    this.proxyGio = function(options) {
        // 在APP环境且APP版本小于GIO切换神策的最低版本，则不代理GIO
        const ua = window ? window.navigator.userAgent : navigator.userAgent;
        if (/botao|jinjiang/i.test(ua) && getJinJiangAppVersion(ua) < SENSORS_MIN_APP_VERSION) {
            return false;
        }

        // 根据gio的host转换神策埋点发送地址
        if (/collect.bestwehotel.com/i.test(options.host)) {
            options.server_url = options.server_url || 'https://sensors-collect-prod.bestwehotel.com/sa?project=production';
        } else {
            options.server_url = options.server_url || 'https://sensors-collect-test.bestwehotel.com/sa?project=default';
        }

        const _this = this;
        _this.initSdk(options); // 初始化神策
        // 接管全局变量gdp，并转换执行神策的方法
        window.gdp = function(key, ...arr) {
            switch (key) {
            case 'track':
                _this.$emit('track', ...arr);
                break;
            case 'setUserId':
                _this.$emit('setMemberId', ...arr);
                _this.$emit('login', ...arr);
                break;
            case 'clearUserId':
            case 'clear':
                _this.$emit('clearMemberId');
                break;
            case 'send':
                // 不做操作
                break;
            default:
                console.warn('您使用的方法不存在');
                break;
            }
        }

        return true;
    };

    // 初始化sdk
    this.initSdk = function(options) {
        if (Object.prototype.toString.call(options) !== '[object Object]') {
            console.warn('初始化神策埋点参数不是Object!');
            return;
        }
        const { dataSourceId, server_url } = options;
        switch (true) {
        case !dataSourceId:
            console.warn('初始化神策埋点参数dataSourceId不能为空！');
            return;
        case !server_url:
            console.warn('初始化神策埋点参数server_url不能为空！');
            return;
        }

        // 判断当前环境
        SENSORS_ENV = /sensors-collect-prod/i.test(options.server_url) ? 'prod' : 'test';

        // 以防重复调用初始化而多次插入脚本
        if (window['sensorsDataAnalytic201505'] && window['sensorsDataAnalytic201505'].init) {
            initData(options);
            return;
        }

        var jsUrl = 'https://static.bestwehotel.com/h5/whsdk/sensors/sensorsdata.1.27.1.js';
        jsUrl = jsUrl + '?dateStamp=' + new Date().toLocaleDateString();
        const aesJsUrl = 'https://static.bestwehotel.com/h5/whsdk/sensors/plugin/aes-encryption/aes-encryption.1.27.1.js' + '?dateStamp=' + new Date().toLocaleDateString();
        const jsUrls = [aesJsUrl, jsUrl];
        const _this = this;
        (function (document, script) {
            const loadScript = (src) => {
                return new Promise((resolve, reject) => {
                    const tag = document.getElementsByTagName('script')[0];
                    script = document.createElement('script');
                    script.async = true;
                    script.src = src;
                    script.onload = resolve;
                    script.onerror = reject;
                    tag.parentNode.insertBefore(script, tag);
                });
            };
            // 防止浏览器不支持Promise.all
            Promise.all = Promise && Promise.all ? Promise.all : { all: myPromiseAll };
            Promise.all(jsUrls.map(loadScript)).then(() => {
                initData(options, _this);
                // 处理因js未加载完成而缓存起来的队列事件
                while(_this.eventQueue.length) {
                    const item = _this.eventQueue.shift();
                    _this.$emit(...item);
                }
            }).catch(err => {
                console.error('神策埋点脚本加载失败！', err);
            });
        })(document, 'script');
    };

    // 触发私有方法（定义私有方法是因为希望外部都能通过$emit方法去触发，而不要直接调用，以便统一处理）
    this.$emit = function(event, ...params) {
        if (!event) {
            return console.warn('你调用的方法不存在！');
        }
        if (window['sensorsDataAnalytic201505'] && window['sensorsDataAnalytic201505'].init) {
            staticMethod[event](...params);
        } else {
            // 脚本未加载完毕，先把需要处理的事件缓存在队列里，待脚本加载完毕统一处理
            this.eventQueue.push([event, ...params]);
        }
    };

    // 代理静态方法，以便用变量名直接调用函数（若有新增静态方法请也在此添加）
    const staticMethod = {
        login: login,
        track: track,
        setMemberId: setMemberId,
        clearMemberId: clearMemberId,
        setProfile: setProfile,
        delProfile: delProfile,
        logout: logout,
    }

    /** 以下都是静态方法，不支持外部调用，仅能在构造函数内或通过$emit方法外部调用 **/

    // 自定义promise.all方法
    function myPromiseAll(promises) {
        if(!Array.isArray(promises)) {
            throw new Error('Promise.all must accept an array');
        }
        return new Promise((resolve,reject) => {
            var res = [];
            for(var i = 0; i < promises.length; i++) {
                function handle(index) {

                    if(!promises[index] instanceof Promise) {
                        reject(new Error('Promise.all must accept an array of promises'));
                    }
                    promises[index].then(data => {
                        res[index] = data;
                        index++;
                        if(index === promises.length) {
                            resolve(res);
                        }
                    },
                    reason => {
                        reject(reason);
                    })
                }
                handle(i);
            }
        })
    }

    // 获取APP版本
    function getJinJiangAppVersion(ua) {
        // exp: v=2.4.1
        var v = /(?=v\=).*/.exec(ua)[0].replace('v=', '');
        // => 2.0401
        // 将 版本号转为 number类型，容易做版本号前后差异对比
        v = v.replace(/(\.\d+)+/, function (match) {
            return '.' + match.slice(1).split('.').map(function (num) {
                return num < 10 ? '0' + num : num;
            }).join('');
        });
        return Number(v);
    }

    // 初始化数据并开启全局自动埋点
    function initData({
        dataSourceId,
        server_url,
        show_log = true,
        is_track_single_page = true,
        app_js_bridge = true,
        max_string_length = 5000,
        heatmap = {},
        otherInitPrams = {},
        publicProp = {},
    }, _this) {
        const sensors = window['sensorsDataAnalytic201505'];

        if (!sensors) {
            console.warn('神策埋点未初始化！');
            return;
        }

        console.warn('当前神策埋点运行环境：', SENSORS_ENV);

        // 页面采集配置
        let totalHeatmap = {
            // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'default',
            // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect',
        };

        totalHeatmap = Object.assign(heatmap, totalHeatmap);

        const options = {
            server_url, // 埋点发送的服务器地址
            is_track_single_page, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
            show_log, // 是否打印埋点信息
            app_js_bridge, // 是否开启App 打通 H5，要APP和H5同时开启，默认设置true
            heatmap: totalHeatmap,
            max_string_length, // 通用字符串最大长度，超过部分会被截取丢弃，默认设置5000
            use_client_time: true, // 是否使用客户端时间
            send_type: 'beacon', // 接口发送类型
            ...otherInitPrams, // 需要额外注入的神策初始化参数
        };

        let aesEncryptionOptions = {
            k: 'UDUPU0FKW/CnHsMZIdWFDA==',
            kid: 1,
            khash: '7ece0c',
        };

        if (SENSORS_ENV === 'prod') {
            aesEncryptionOptions = {
                k: '424FtB+Q92Xi1jrEftnV6A==',
                kid: 1,
                khash: '2e47bb',
            };
        }

        // 初始化加密插件
        if (window['SensorsDataWebJSSDKPlugin'] &&
            window['SensorsDataWebJSSDKPlugin']['AesEncryption'] &&
            sensors && sensors.use && aesEncryptionOptions) {
            sensors.use('AesEncryption', aesEncryptionOptions);
        }

        sensors.init(options);

        // 若在小程序内，应在初始化后接收URL的unionidID、userId和dataSourceId，并将之应用
        if (ifMpInside() ) {
            const unionidID = getQuery('unionidID') || '';
            const userId = getQuery('userId') || getQuery('jjid') || '';
            const urlDataSourceId = getQuery('dataSourceId') || '';
            // 登录神策
            if (userId) {
                window['sensorsDataAnalytic201505'].login(userId); // 关联登录的ID
            }
            // 关联小程序
            if (unionidID) {
                window['sensorsDataAnalytic201505'].bind("$identity_mp_unionid", unionidID);
            }
            // 小程序内H5的dataSourceId要用小程序的
            if (urlDataSourceId) {
                dataSourceId = urlDataSourceId;
            }
        }

        // 设置事件静态公共属性
        sensors.registerPage({
            dataSourceId,
            ...publicProp, // 需要额外添加的公共属性
        });

        // 开启自动埋点
        sensors.quick('isReady', function() {
            sensors.quick('autoTrack');
        });

        function parseQuery(url) {
            url = url || '';
            const queryObj = {};
            const reg = /[?&]([^=&#]+)=([^&#]*)/g;
            const queryArr = url.match(reg) || [];
            // eslint-disable-next-line no-unused-vars
            for (const i in queryArr) {
                if (Object.hasOwnProperty.call(queryArr, i)) {
                    const query = queryArr[i].split('=');
                    const key = query[0].substr(1);
                    const value = decodeURIComponent(query[1]);
                    queryObj[key]
                        ? (queryObj[key] = [].concat(queryObj[key], value))
                        : (queryObj[key] = value);
                }
            }
            return queryObj;
        }

        function getQuery(key) {
            const queryObj = parseQuery(window.location.href);
            return queryObj[key];
        }
    }

    // 用户登入
    function login(loginId) {
        window['sensorsDataAnalytic201505'].login(loginId); // 关联登录的ID
    }

    // 用户登出
    function logout() {
        window['sensorsDataAnalytic201505'].resetAnonymousIdentity(); // 重置匿名ID
        window['sensorsDataAnalytic201505'].logout(); // 退出登录
    }

    // 是否在小程序内
    function ifMpInside() {
        const ua = window.navigator.userAgent;
        if (window.__wxjs_environment === 'miniprogram' || (/miniprogram/i.test(ua) && /MicroMessenger/i.test(ua))) {
            return true; // 微信小程序
        } else if ((/alipay/i.test(ua) || /aliapp/i.test(ua)) && (/miniProgram/i.test(ua) || /alipayide/i.test(ua))) { // 兼容开发工具没有miniProgram，而是alipayide
            return true; // 支付宝小程序
        }
        return false;
    }

    // 自定义埋点
    function track(event, params) {
        window['sensorsDataAnalytic201505'].track(event, { ...params });
    }

    // 设置会员ID
    function setMemberId(currentMemberId) {
        if (window['sensorsDataAnalytic201505']) {
            if (this.oldMemberId === currentMemberId) {
                return;
            }
            this.oldMemberId = currentMemberId;
            if (currentMemberId) {
                setProfile({ userId: currentMemberId });
            } else {
                clearMemberId();
            }
        }
    }

    // 清空会员ID
    function clearMemberId() {
        delProfile(['userId']);
    }

    // 设置自定义属性
    function setProfile(obj) {
        if (Object.prototype.toString.call(obj) !== '[object Object]') {
            return console.warn('自定义属性参数不是Object!');
        }
        window['sensorsDataAnalytic201505'].setProfile(obj);
    }

    // 删除自定义属性
    function delProfile(keys) {
        if (keys) {
            window['sensorsDataAnalytic201505'].unsetProfile(keys);
        } else {
            window['sensorsDataAnalytic201505'].deleteProfile();
        }
    }
}

const wehotelSensors = new MySensors();

export default wehotelSensors;



// WEBPACK FOOTER //
// ./src/assets/js/wehotel.sensors.sdk.js